import _ from "lodash"
import * as R from "ramda"


export const getCardData = (data: any, cardname: any) => {
    if (data?.length) {
        const cardData: any = _.filter(data, ['CardName', cardname])[0]?.CardValue || []
        const cardVaules: any = cardData.length > 0 ? JSON.parse(cardData) : []

        const values = cardVaules ? JSON.parse(JSON.stringify(cardVaules)) : [];

        const transformedValues: any = [];
        let ictr = 0
        R.map(
            (valueSet: any) => {
                transformedValues.push([])
                R.map(
                    (value: any) => {
                        transformedValues[ictr].push({
                            [value.field]: value.value
                        })
                        return value
                    },
                    valueSet
                )
                transformedValues[ictr] = R.mergeAll(transformedValues[ictr])
                ictr += 1
                return valueSet
            },
            values
        )
        return transformedValues

    }

}

export const getBrandMapping = (data: any, cardname: any) => {
    if (data?.length) {
        const cardData: any = _.filter(data, ['CardName', cardname])[0]?.CardValue || []
        const cardVaules: any = cardData.length > 0 ? JSON.parse(cardData) : []
        return _.map(cardVaules, (card: any) => {
            const lightLogo = _.find(card?.Configurations.Logos, ["Background", "Dark"]) || card?.Configurations?.Logos[0]
            const logoDark = _.find(card?.Configurations.Logos, ["Background", "Light"]) || card?.Configurations?.Logos[0]
            const favIconDark = _.find(card?.Configurations.Favicons, ["Background", "Light"]) || card?.Configurations?.Favicons[0]
            const favIconLight = _.find(card?.Configurations.Favicons, ["Background", "Dark"]) || card?.Configurations?.Favicons[0]
            const brandMapping = {
                themeName: card?.Theme,
                logoLight: lightLogo?.Url,
                logoDark: logoDark?.Url,
                favIconLight: favIconLight?.Url,
                favIconDark: favIconDark?.Url

            }
            return brandMapping;
        })
    }
}

export const getFunctionCardData = (data: any, cardname: any) => {
    if (data?.length) {
        const cardData: any = _.filter(data, ['CardName', cardname])[0]?.CardValue || []
        const cardVaules: any = cardData.length > 0 ? JSON.parse(cardData) : []

        const values = cardVaules ? JSON.parse(JSON.stringify(cardVaules)) : [];
        return values

    }

}
